@if (msalUserInfoFetched) {
    <router-outlet></router-outlet>
}